export default "__VITE_ASSET__D3lFE8j$__"